<template>
  <section
    v-bind="containerProps ? containerProps : {}"
    class="carousel-container"
    data-ride="carousel"
  >
    <div
      v-bind="wrapperProps ? wrapperProps : {}"
      class="carousel-container__inner"
    >
      <slot />
    </div>
  </section>
</template>

<script setup>
  import { onMounted, onBeforeUnmount } from 'vue';

  const props = defineProps({
    isInfinite: Boolean,
    distanceToCheck: {
      type: Number,
      default: 200,
    },
    containerProps: {
      type: Object,
      required: false,
    },
    wrapperProps: {
      type: Object,
      required: false,
    },
  });
  const emit = defineEmits(['scroll-start', 'scroll-end', 'fetch-more']);

  onMounted(() => {
    if (props.isInfinite) {
      carouselContainer.addEventListener('scroll', checkScroll);
    }
  });

  onBeforeUnmount(() => {
    if (props.isInfinite) {
      carouselContainer.removeEventListener('scroll', checkScroll);
    }
  });

  const checkScroll = (event) => {
    if (!props.isInfinite) return;
    const { scrollLeft, scrollWidth, clientWidth } = event.target;
    const scrollEnd = scrollWidth - clientWidth;

    if (scrollLeft === 0) {
      emit('scroll-start');
    } else if (scrollLeft === scrollEnd) {
      emit('scroll-end');
    } else if (
      scrollLeft + clientWidth >=
      scrollWidth - props.distanceToCheck
    ) {
      emit('fetch-more');
    }
  };
</script>

<style lang="scss" scoped>
  .carousel-container {
    position: relative;
    width: 100%;
    height: 100%;
    overflow-x: auto;
    overflow-y: hidden;
    scroll-snap-type: x mandatory;

    /* SCROLLBARS HAVE CHANGED https://developer.chrome.com/docs/css-ui/scrollbar-styling */
    /* Modern browsers with `scrollbar-*` support */
    @supports (scrollbar-width: auto) {
      scrollbar-width: thin;
      scrollbar-color: var(--itr-grey-mid) var(--itr-grey-soft);
    }

    /* Legacy browsers with `::-webkit-scrollbar-*` support */
    @supports selector(::-webkit-scrollbar) {
      &::-webkit-scrollbar {
        height: 10px;
        width: 10px;
      }

      &::-webkit-scrollbar-track {
        background-color: var(--itr-grey-soft);
        border-radius: 100px;
      }

      &::-webkit-scrollbar-thumb {
        border: 2px solid transparent;
        background-color: var(--itr-grey-mid);
        border-radius: 100px;
      }
    }

    &__inner {
      display: flex;
      position: relative;
      width: fit-content;
      height: 100%;
      gap: 16px;
    }
  }
</style>
